'use client';
import type { ReactNode } from 'react';
import { useRef } from 'react';
import { usePathname } from 'next/navigation';

import { ContactForm, RichContent } from '@common';

import { usePushToDataLayerOnce } from '@hooks';

import Portal from '@components/common/PortalContent';
import { SubscribeEmailToNewsletter } from '@components/common/SubscribeEmailToNewsletter';

import { FaqAnchors } from './FaqAnchors';

export const LandingPages = ({
  data,
  productsHighlight
}: {
  data: any;
  productsHighlight?: ReactNode;
}) => {
  const pathname = usePathname();
  const faqContentRef = useRef<HTMLDivElement>(null);
  const { cmsPage } = data;
  const isFaqPage =
    cmsPage.url_key === 'faq' ||
    pathname === '/faq/l' ||
    pathname === '/faq' ||
    pathname === '/faq/';

  usePushToDataLayerOnce('cms', {
    title: cmsPage.meta_title || cmsPage.title,
    page_type: 'landingPage'
  });
  return (
    <>
      {isFaqPage ? (
        <div ref={faqContentRef}>
          <RichContent html={cmsPage.content} />
          <FaqAnchors rootRef={faqContentRef} />
        </div>
      ) : (
        <RichContent html={cmsPage.content} />
      )}
      {productsHighlight}
      {pathname === '/atendimento/l' && (
        <Portal id="contact_form">
          <ContactForm />
        </Portal>
      )}
      <Portal id="newsletter_form">
        <div className="styles-background-3R6">
          <div className="styles-container-YrW">
            <div className="styles-divRight-306">Fique por dentro</div>
            <div className="styles-divRight-307">
              Receba nossas novidades e promoções.
            </div>
            <div>
              <section className="flex flex-col w-[90%] md:w-[450px] mx-auto styles-button-container">
                <SubscribeEmailToNewsletter
                  label="Cadastrar"
                  originId="landing-page"
                />
              </section>
            </div>
          </div>
        </div>
      </Portal>
    </>
  );
};
